import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { legalDocs, LegalDoc } from '../data/legal';
export function Footer() {
  const [activeDoc, setActiveDoc] = useState<LegalDoc | null>(null);
  return <footer className="border-t border-white/5 bg-ink-900 py-10" data-id="element-25" data-mp="32ovvcp86ejhi">
      <div className="mx-auto max-w-6xl px-5" data-id="element-26" data-mp="36p6buvtlgsam">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-27" data-mp="36pzaf9iegbho">
          Gym por Primera Vez
        </p>
        <p className="mt-3 max-w-2xl text-xs leading-relaxed text-white/40" data-id="element-28" data-mp="38qu4u3bljp2">
          Este material es informativo y no sustituye la orientación de un médico. Consulta a un profesional de la salud
          antes de comenzar cualquier programa de ejercicio. Los resultados varían según cada persona.
        </p>

        <nav aria-label="Avisos legales" className="mt-5" data-id="element-29" data-mp="29ynmxp3fzdg4">
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-30" data-mp="2a19u3nmf7qxt">
            {legalDocs.map(doc => <li key={doc.id} data-id="element-31" data-mp="2evxa0y3czd0s">
                <button type="button" onClick={() => setActiveDoc(doc)} className="rounded text-xs font-semibold text-white/55 underline decoration-white/20 underline-offset-4 outline-none transition-colors duration-150 ease-smooth hover:text-flame hover:decoration-flame/60 focus-visible:ring-2 focus-visible:ring-flame/50" data-id="element-32" data-mp="3l90pe0juz71d">
                  {doc.label}
                </button>
              </li>)}
          </ul>
        </nav>

        <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-white/40" data-id="element-33" data-mp="32w1tqajr697">
          <span data-id="element-34" data-mp="hrs6rehb435l">© {new Date().getFullYear()} Gym por Primera Vez</span>
          <a href="#faq-title" className="transition-colors duration-150 ease-smooth hover:text-white" data-id="element-35" data-mp="cu0gsq082r41">
            Preguntas frecuentes
          </a>
          <a href="mailto:soporte@gymporprimeravez.com" className="transition-colors duration-150 ease-smooth hover:text-white" data-id="element-36" data-mp="qu1exxp3rkft">
            soporte@gymporprimeravez.com
          </a>
        </div>
      </div>

      <LegalModal doc={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-37" data-mp="yu7iquzf5vzs" />
    </footer>;
}